@if (payment) {
    <app-logged-in-user-detail label="IBAN">
        {{ payment.iban | mangle }}
    </app-logged-in-user-detail>
    <app-logged-in-user-detail label="Bank">
        {{ payment.nameOfBank }}
    </app-logged-in-user-detail>
    <app-logged-in-user-detail label="Kontoinhaber">
        {{ payment.accountHolder }}
    </app-logged-in-user-detail>
    <app-navigation-buttons
        [showBack]="isFirstStep"
        (prev)="prev.emit({})"
        (next)="next.emit({})"
    >
    </app-navigation-buttons>
}
